import { useAuth } from "../../hooks/useAuth";
import { Link, useParams } from "react-router-dom";
import { VisaSupportWorkspace } from "../../../../shared/src/components/visa-support/VisaSupportWorkspace";
import { agentVisaApi } from "../../services/agentApi";
export function VisaSupportPage() {
  const { id } = useParams();
  const { user } = useAuth();
  const applicationId = Number(id);
  return (
    <div className="container-fluid py-4">
      <Link className="d-inline-block mb-3" to={`/applications/${id}`}>
        ← Back to application details
      </Link>
      {/^[1-9]\d*$/.test(id || "") &&
      Number.isSafeInteger(applicationId) &&
      applicationId > 0 ? (
        <VisaSupportWorkspace
          applicationId={applicationId}
          accountKey={String(user?.id || "signed-out")}
          api={agentVisaApi}
        />
      ) : (
        <p role="alert">Invalid application ID</p>
      )}
    </div>
  );
}
